<template>
    <!-- available sub-categories -->
    <div class="row">
        <div class="col-12">
            <!-- display sub categories -->
            <div v-if="theSubCategories" class="table-responsive">
                <table class="table table-hover mt-3">
                    <thead class="bg-silver">
                        <tr>
                            <th scope="col">No.</th>
                            <th scope="col">SubCategories</th>
                            <th scope="col" class="text-center text-truncate">Express $</th>
                            <th scope="col" class="text-center text-truncate">Economy $</th>
                            <th scope="col" class="text-center text-truncate">Budget $</th>
                            <th scope="col" class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <app-sub-category-fee v-for="(subCategory, i) in theSubCategories" 
                            :key="i" :categoryName="categoryName" :subCategoryObj="subCategory" :counter="i+1">
                        </app-sub-category-fee>
                    </tbody>
                </table>
            </div>

            <!-- no sub categories found -->
            <div v-else class="card my-3">
                <div class="card-body text-center text-danger">
                    <p>No sub-category found for {{categoryName}} category!</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SubCategoryFee from './SubCategoryFee.vue'
export default {
    name: "SubCategoriesFees",
    props: {
        categoryName: {
            type: String,
            required: true
        }
    },
    methods: {
        ...mapActions(['fetchSubCategoriesAction']),
        fetchSubCategoriesFxn(theCategoryName) {
            let subCategoryObj = {
                categoryName: theCategoryName
            }
            this.fetchSubCategoriesAction(subCategoryObj).then(() => {}).catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['setMainSubCategories']),
        theSubCategories(){
            if(this.setMainSubCategories && this.setMainSubCategories.length){
                return this.setMainSubCategories
            }
            return false 
        },
    },
    watch: {
        categoryName(){
            this.fetchSubCategoriesFxn(this.categoryName)
        }
    },
    components: {
        appSubCategoryFee: SubCategoryFee
    }
}
</script>